import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
shareLinkStyles.link = {
    link: {
        css: css`
            text-align: left;
            padding-right: 8px;
            margin-left: 8px;
        `,
    },
};

// EC-617 - [FE] Fix Text overlapping on share icon
shareLinkStyles.wrapper = {
    css: css`
        text-align: left;
        margin-top: 10px; // EC-617 : Fixing css issues on PLP & PDP

        [data-test-selector="productShareLink"] {
            padding-right: 8px;
            font-size: 12px; // EC-617 : Fixing css issues on PLP & PDP
        }
        @media screen and (max-width: 768px) {
            display: flex;
            justify-content: center;
            align-items: center;
            [data-test-selector="productShareLink"] {
                text-indent: -9999px;
                background: url("/userfiles/pdp/share16.svg?width=16&height=16") no-repeat;
                width: 16px;
                height: 16px;
                border: none;
            }
        }
    `,
};
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS. */
